const languages = () => ({
  en: { name: 'English' },
  el: { name: 'Ελληνικά' },
  // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
});

export default languages;
